













import { Component, Vue } from 'vue-property-decorator';
import LoginForm from '@/components/Login/LoginForm.vue';

@Component({
  components: {
    LoginForm,
  },
})
export default class LogIn extends Vue {

}
